import gql from "graphql-tag";

const query = gql`
  query Me($propertyID: String!, $roomID: Int!) {
    getGuest(propertyID: $propertyID, roomID: $roomID) {
      code
      message
      property_id
      guest_id
      guest_name
    }
  }
`;

export default query;
